import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { customerAddressFormStyles } from "@insite/content-library/Components/CustomerAddressForm";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

customerAddressFormStyles.cancelButton = {
    variant: "secondary",
    hoverMode: "none",
    css: css`
        background: ${getColor("primary.contrast")};
        color: ${getColor("text.accent")};
        border: 2px solid ${getColor("text.accent")};
    `,
};

customerAddressFormStyles.formButtonsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
        gap: 15px;
    `,
};
